"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stediSpecificBindings = void 0;
const dateTime_1 = require("./dateTime");
// import { omitArrayItemConstantDocumentation } from "./omitArrayItem";
const omitField_1 = require("./omitField");
exports.stediSpecificBindings = [
    ...dateTime_1.dateTimeConstantsDocumentation,
    // TODO: This is temporarily commented out, to avoid public documentation of this feature.
    // We might decide to remove this constant entirely and re-use the `omitField` constant instead (which would be a breaking change).
    // ...omitArrayItemConstantDocumentation,
    ...omitField_1.omitFieldConstantDocumentation,
];
